import { PeroanlPackagefood } from './../core/model/api-response/persoanl-response-model';
import { packagesFood } from './../core/model/api-response/plans-response-model';
import { DietFoodModel } from './../core/model/object/diet-model';
import { DietMealModel } from '../core/model/object/diet-model';
import {
  FoodModel,
  FoodUnitIdModel,
  FoodUnitRatioModel,
} from '../core/model/object/diet-food-model';
import { FoodLogModel } from '../core/model/object/foodlog-model';
import { Perosnlapackages } from '../core/model/api-response/persoanl-response-model';
import { Injectable } from '@angular/core';

@Injectable()
export class CalorieCalculator {
  constructor() {}

  calculateSuggestions(
    foods: packagesFood[],
    amount: {
      amount: number;
    }[]
  ) {
    let calorie = 0;
    foods.forEach((food, i) => {
      calorie += Math.floor(this.calculateSuggestion(food, amount[i].amount));
    });
    return Math.floor(calorie);
  }
  calculateSuggestion(food: packagesFood, amount: number) {
    const ratio = this.findSuggestionRatio(food);
    const calorie = food.foodId.foodFact.calorieAmount;
    return ((amount * calorie) / 100) * ratio.ratio;
  }
  findSuggestionRatio(food: packagesFood): FoodUnitRatioModel {
    let ratio: FoodUnitRatioModel;
    let isGram = false;
    let primaryFoodUnit = '';
    if (food.foodId.primaryFoodUnit) {
      primaryFoodUnit = food.foodId.primaryFoodUnit;
    } else {
      primaryFoodUnit = food.foodId.primaryFoodUnit;
    }
    if (
      primaryFoodUnit === '' ||
      primaryFoodUnit === '5e1c595d883a966e03fb4530'
    ) {
      isGram = true;
    }
    if (isGram) {
      ratio = new FoodUnitRatioModel(
        1,
        new FoodUnitIdModel('گرم', '5e1c595d883a966e03fb4530')
      );
    } else {
      food.foodId.foodUnitRatioArray.forEach((r) => {
        if (r.unitId._id === primaryFoodUnit) {
          ratio = r;
        }
      });
    }
    return ratio;
  }
  calculateMealCalorie(meal: DietMealModel) {
    let calorie = 0;
    meal.foods.forEach((food) => {
      if (food.foodModel) {
        calorie += this.calculateFoodCalorie(food);
      }
    });

    return Math.floor(calorie);
  }

  calculateFoodCalorie(food: DietFoodModel) {
    const ratio = this.findFoodRatio(food);
    return (
      ((food.amount * food.foodModel.foodFactModel.calorie.amount) / 100) *
      ratio.ratio
    );
  }

  findFoodRatio(food: DietFoodModel): FoodUnitRatioModel {
    let ratio: FoodUnitRatioModel;
    let isGram = false;
    let primaryFoodUnit = '';
    if (food.unit) {
      primaryFoodUnit = food.unit;
    } else if (food.foodModel && food.foodModel.primaryFoodUnit) {
      primaryFoodUnit = food.foodModel.primaryFoodUnit;
    } else {
      primaryFoodUnit = '5e1c595d883a966e03fb4530';
    }
    if (
      primaryFoodUnit === '' ||
      primaryFoodUnit === '5e1c595d883a966e03fb4530'
    ) {
      isGram = true;
    }
    if (isGram) {
      ratio = new FoodUnitRatioModel(
        1,
        new FoodUnitIdModel('گرم', '5e1c595d883a966e03fb4530')
      );
    } else {
      food.foodModel.foodUnitRatioArray.forEach((r) => {
        if (r.unitId._id === primaryFoodUnit) {
          ratio = r;
        }
      });
    }
    return ratio;
  }

  calculateFoodLogsCalorie(foodLogs: FoodLogModel[]): number {
    let calorie = 0;
    foodLogs.forEach((food) => {
      if (food.calorie && food.title) {
        calorie += food.calorie;
      } else {
        calorie += this.calculateFoodLogCalorie(food);
      }
    });
    return calorie;
  }

  calculateFoodLogCalorie(foodLog: FoodLogModel): number {
    const ratio = this.findFoodLogRatio(foodLog);
    if (foodLog.calorie && foodLog.title) {
      return foodLog.calorie;
    }
    return (
      ((foodLog.amount * foodLog.foodModel.foodFactModel.calorie.amount) /
        100) *
      ratio.ratio
    );
  }

  findFoodLogRatio(foodLog: FoodLogModel): FoodUnitRatioModel {
    let ratio: FoodUnitRatioModel;
    let isGram = false;
    if (foodLog.calorie && foodLog.title) {
      ratio = new FoodUnitRatioModel(
        1,
        new FoodUnitIdModel('گرم', '5e1c595d883a966e03fb4530')
      );
    } else {
      let primaryFoodUnit = '';
      if (foodLog.unit) {
        primaryFoodUnit = foodLog.unit;
      } else {
        primaryFoodUnit = foodLog.foodModel.primaryFoodUnit;
      }
      if (
        primaryFoodUnit === '' ||
        primaryFoodUnit === '5e1c595d883a966e03fb4530'
      ) {
        isGram = true;
      }
      if (isGram) {
        ratio = new FoodUnitRatioModel(
          1,
          new FoodUnitIdModel('گرم', '5e1c595d883a966e03fb4530')
        );
      } else {
        foodLog.foodModel.foodUnitRatioArray.forEach((r) => {
          if (r.unitId._id === primaryFoodUnit) {
            ratio = r;
          }
        });
      }
    }
    return ratio;
  }

  calculatePackagesCalorie(foods: PeroanlPackagefood[]) {
    let calorie = 0;
    foods.forEach((food, i) => {
      calorie += this.calculatePackageCalorie(food, food.amount);
    });
    return Math.ceil(calorie);
  }
  calculatePackageCalorie(food: PeroanlPackagefood, amount: number) {
    const ratio = this.calculatePackagesRatio(food.food as FoodModel);
    return (
      ((food.amount * (food.food as FoodModel).foodFactModel.calorie.amount) /
        100) *
      ratio.ratio
    );
  }
  calculatePersonalPackageFoods(foods: [FoodModel, number][]) {
    let calorie = 0;
    foods.forEach((food, i) => {
      calorie += this.calculatePersonalPackageFood(food[0], food[1]);
    });
    return Math.ceil(calorie);
  }
  calculatePersonalPackageFood(food: FoodModel, amount: number) {
    const ratio = this.calculatePackagesRatio(food);
    return ((amount * food.foodFact.calorieAmount) / 100) * ratio.ratio;
  }
  calculatePackagesRatio(food: FoodModel): FoodUnitRatioModel {
    let ratio: FoodUnitRatioModel;
    let isGram = false;
    let primaryFoodUnit = '';
    if (food.primaryFoodUnit) {
      primaryFoodUnit = food.primaryFoodUnit;
    } else {
      primaryFoodUnit = food.primaryFoodUnit;
    }
    if (
      primaryFoodUnit === '' ||
      primaryFoodUnit === '5e1c595d883a966e03fb4530'
    ) {
      isGram = true;
    }
    if (isGram) {
      ratio = new FoodUnitRatioModel(
        1,
        new FoodUnitIdModel('گرم', '5e1c595d883a966e03fb4530')
      );
    } else {
      food.foodUnitRatioArray.forEach((r) => {
        if (r.unitId._id === food.primaryFoodUnit) {
          ratio = r;
        }
      });
    }
    return ratio;
  }
}
